import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form } from 'redux-form';
import { FormTextField, FormSelect } from 'appSrc/components/UI/ReduxForm';
import { PrimaryButton } from 'appSrc/components/UI';
import style from '../styles/style.module.css';

const validate = {
    required: ( value ) => ( ( value == null || !/\S/.test( value ) ) ? 'Required' : undefined ),
};

class StepOneForm extends PureComponent {
    constructor(props) {
        super(props);
    }
    noDuplicate = ( value ) => {
        var nameExists = this.props.ownLists.some( ( list ) => {
            var ret = list.title == value;
            return ret;
        } );
        var resp = nameExists ? 'You already have a list with this name' : undefined;
        return  resp;
    }
    render() {
        const { handleSubmit, submitting, user, valid } = this.props;
        return (
            <Form className={ style.stepOneForm } onSubmit={ handleSubmit( this.props.onSubmit ) } key='list-creation-step-one' >
                <Field
                id="title"
                name="title"
                label="Name Your List"
                component={ FormTextField }
                fullWidth
                autoFocus
                validate={ [ validate.required, this.noDuplicate ] } />
                { user.interests.length > 0 &&
                    <Field
                    id='channel'
                    name='channel'
                    component={ FormSelect }
                    label='Category'
                    options={ [ { text: 'No Category', value: null },
                        ...user.interests.filter( channel => !channel.deactivated ).map( channel => ( {
                            text: channel.interest,
                            value: channel.interestid,
                        } ) ) ] }
                    fullWidth />
                }
                <div className={ style.submitButton } style={ { marginTop: '15px' } }>
                    <PrimaryButton
                    label="Next"
                    type="submit"
                    fullWidth
                    disabled={ !valid || submitting } />
                </div>
                { this.props.error &&
                    <div className={ style.errorBlock }>{ this.props.error }</div>
                }
            </Form>
        );
    }
}

StepOneForm = reduxForm( {
    form: 'ListCreationStepOneForm',
} )( StepOneForm );

const mapStateToProps = ( state ) => {
    return {
        user: state.self.user,
        ownLists: state.self.lists,
    };
};

export default connect( mapStateToProps )( StepOneForm );
